module.exports = __webpack_public_path__ + "static/media/avatar-confetti.aa1b1b09.png";